import React from "react";
import { color, lightest } from "../..";

export function PointSymbol(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 10 10" {...props}>
      <circle cx="5" cy="5" r="5" fill={props.color || "black"} />
      <circle
        cx="5"
        cy="5"
        r="3"
        fill={props.fill ?? (props.color && lightest(props.color)) ?? color.hydrogen}
      />
    </svg>
  );
}

export function PointSymbolStroke(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <circle
        cx="10"
        cy="10"
        r="7"
        fill={props.fill ?? (props.color && lightest(props.color)) ?? color.hydrogen}
        stroke={props.color || "black"}
        strokeWidth="7"
      />
    </svg>
  );
}

export function SquareMarker(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 10 10" {...props}>
      <rect x="0" y="0" width="10" height="10" fill={props.color || "black"} />
    </svg>
  );
}

export function DiamondMarker(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 10 10" {...props}>
      <polygon points="0 5,5 10,10 5,5 0" fill={props.color || "black"} />
    </svg>
  );
}

export function CircleDiamondMarker(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="10" height="10" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="45" cy="45" r="45" fill={props.color || "black"} />
      <rect
        x="11"
        y="45"
        width="48.0833"
        height="48.0833"
        transform="rotate(-45 11 45)"
        fill="white"
        fillOpacity="0.85"
      />
    </svg>
  );
}

export function PartialValidCircleMarker(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 9 10" {...props} fill="none">
      <circle
        cx="4.5"
        cy="5"
        r="4"
        fill={color.darkNitrogen50}
        stroke={color.darkNitrogen600}
        strokeWidth="1"
      />
    </svg>
  );
}
